// theme/theme.js
import { createTheme } from "@mui/material/styles";

// ✅ Единая типографика (адаптивные размеры для всех заголовков и текста)
const typography = {
  fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,

  h1: { fontWeight: 800, lineHeight: 1.05, fontSize: "clamp(2.6rem, 6vw, 4.5rem)" },
  h2: { fontWeight: 700, lineHeight: 1.10, fontSize: "clamp(2.1rem, 5vw, 3.75rem)" },
  h3: { fontWeight: 700, lineHeight: 1.15, fontSize: "clamp(1.6rem, 4vw, 2.6rem)" },
  h4: { fontWeight: 600, lineHeight: 1.20, fontSize: "clamp(1.3rem, 3vw, 2rem)" },
  h5: { fontWeight: 600, lineHeight: 1.25, fontSize: "clamp(1.1rem, 2.5vw, 1.6rem)" },
  h6: { fontWeight: 600, lineHeight: 1.30, fontSize: "clamp(1rem, 2vw, 1.25rem)" },

  subtitle1: { fontWeight: 500, lineHeight: 1.4, fontSize: "clamp(1rem, 2vw, 1.25rem)" },
  subtitle2: { fontWeight: 500, lineHeight: 1.4, fontSize: "clamp(0.9rem, 1.8vw, 1.1rem)" },

  body1: { fontWeight: 400, lineHeight: 1.6, fontSize: "clamp(0.95rem, 1.6vw, 1.1rem)" },
  body2: { fontWeight: 400, lineHeight: 1.55, fontSize: "clamp(0.85rem, 1.4vw, 1rem)" },

  button: { fontWeight: 600, textTransform: "none", fontSize: "clamp(0.9rem, 1.4vw, 1rem)" },
  caption: { fontWeight: 400, lineHeight: 1.4, fontSize: "clamp(0.75rem, 1.2vw, 0.85rem)" },
  overline: {
    fontWeight: 500,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontSize: "clamp(0.7rem, 1vw, 0.8rem)",
  },
};

// ✅ Компоненты вынесены на верхний уровень (у тебя было ошибочно внутри palette)
const components = (mode) => ({
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: mode === "light" ? "#f5f5f5" : "#121212",
        color: mode === "light" ? "#3c3c3C" : "#ffffff",
      },
      "#__next": {
        position: "relative",
      },
      a: {
        textDecoration: "none",
        color: "inherit",
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backdropFilter: "blur(10px)",
        backgroundColor:
          mode === "light" ? "rgb(255, 255, 255)" : "rgb(30, 30, 30)",
      },
    },
  },
});

// Светлая тема
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0073ff",
      light: "#80B9FF",
      dark: "#003A80",
      contrastText: "#ffffff",
    },
    secondary: { main: "#FF6B00" },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
    text: {
      primary: "#292D33",
      secondary: "#555555",
    },
    // статусы
    success: { light: "#36B361", main: "rgb(82, 178, 2)", dark: "#007D2B", contrastText: "#fff" },
    error: { light: "#ff564D", main: "rgb(211, 47, 47)", dark: "#800600", contrastText: "#fff" },
    warning: { light: "#FFAF4D", main: "#FF8C00", dark: "#B36200", contrastText: "#fff" },
    info: { light: "#81d4fa", main: "#00A0FF", dark: "#01579b", contrastText: "#fff" },

    // ⚠️ Нестандартное поле (MUI его не использует автоматически) — оставляю как у тебя,
    // чтобы ты мог брать theme.palette.body.* вручную в sx.
    body: {
      backgroundColor: "#021520",
      backgroundImage:
        "radial-gradient(circle at 20% 30%, #9FE7F5 0%, transparent 60%), radial-gradient(circle at 80% 70%, #F27F0C 0%, transparent 60%)",
      backgroundAttachment: "fixed",
      backgroundBlendMode: "overlay",
      color: "#fff",
    },
  },

  typography,
  components: components("light"),
});

// Тёмная тема
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#90caf9",
      light: "#e3f2fd",
      dark: "#42a5f5",
      contrastText: "#000000",
    },
    secondary: { main: "#FF6B00" },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#aaaaaa",
    },
  },

  typography,
  components: components("dark"),
});
